import { VIEWS } from './consts';
import type { InitStepProps } from './types';

export function getInitStep(props: InitStepProps) {
  const { customizedInitStep, isCreationMethodEnabled } = props;
  if (customizedInitStep) {
    return customizedInitStep;
  } else if (isCreationMethodEnabled) {
    return VIEWS.CREATION_METHOD;
  }
  return VIEWS.GOALS;
}
